import React from 'react';
import { ExternalLink } from 'lucide-react';

const CaseCard = ({ image, title, company, challenge, solution, result }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
      <div className="h-48 bg-aug-blue-light overflow-hidden">
        <img 
          src={image || 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80'} 
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-aug-gray-dark mb-2">{title}</h3>
        <p className="text-sm text-aug-blue font-medium mb-4">{company}</p>
        
        <div className="space-y-3 mb-4">
          <div>
            <h4 className="font-semibold text-aug-gray-dark text-sm mb-1">Desafio:</h4>
            <p className="text-sm text-aug-gray-medium">{challenge}</p>
          </div>
          <div>
            <h4 className="font-semibold text-aug-gray-dark text-sm mb-1">Solução:</h4>
            <p className="text-sm text-aug-gray-medium">{solution}</p>
          </div>
          <div>
            <h4 className="font-semibold text-aug-gray-dark text-sm mb-1">Resultado:</h4>
            <p className="text-sm text-aug-green-success font-medium">{result}</p>
          </div>
        </div>
        
        <button className="flex items-center text-aug-blue hover:text-aug-green transition-colors duration-300 font-medium text-sm">
          Ver Case Completo
          <ExternalLink className="w-4 h-4 ml-1" />
        </button>
      </div>
    </div>
  );
};

export default CaseCard;